import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "../pages/HeaderResponsive.css";

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const userStr = localStorage.getItem("user");
    if (userStr) {
      setUser(JSON.parse(userStr));
    } else {
      setUser(null);
    }
  }, [location]);

  const [isNavOpen, setIsNavOpen] = useState(false);

  const handleNavClick = () => {
    setIsNavOpen(false);
  };

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  const isProfilePage =
    location.pathname === "/profile" ||
    location.pathname === "/driver/profile" ||
    location.pathname === "/hotel/profile" ||
    location.pathname === "/travels/profile" ||
    location.pathname === "/admin";

  const handleMyAccountClick = (e) => {
    e.preventDefault();
    handleNavClick();
    const userStr = localStorage.getItem("user");

    if (!userStr) {
      navigate("/login");
      return;
    }

    try {
      const user = JSON.parse(userStr);
      switch (user.role) {
        case "driver":
          navigate("/driver/profile");
          break;
        case "hotel":
          navigate("/hotel/profile");
          break;
        case "travels":
          navigate("/travels/profile");
          break;
        case "admin":
          navigate("/admin");
          break;
        case "user":
        default:
          navigate("/profile");
          break;
      }
    } catch (err) {
      console.error("Error parsing user data:", err);
      navigate("/login");
    }
  };

  return (
    <>
      <header className="header">
        <div className="header-top">
          <div className="container">
            <div className="header-top-wrapper">
              <div className="header-top-left">
                <div className="header-top-contact">
                  <ul>
                    <li style={{ display: "inline-flex", alignItems: "center" }}>
                      <i className="fab fa-whatsapp" style={{ color: "#fbb710", marginRight: "5px" }} />
                      <span style={{ color: "#fff", marginRight: "5px", fontSize: "14px", fontWeight: "500" }}>WhatsApp Only:</span>
                      <a
                        href="https://wa.me/919723047222"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ padding: 0 }}
                      >
                        9723047222
                      </a>
                      <span style={{ color: "#fff", margin: "0 4px", fontSize: "14px", fontWeight: "500" }}>/</span>
                      <a
                        href="https://wa.me/919723048222"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ padding: 0 }}
                      >
                        9723048222
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="far fa-alarm-clock" /> Mon - Fri (08AM -
                        10PM)
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div
                className="header-top-right"
                style={{ display: "flex", alignItems: "center", gap: "15px" }}
              >
                <div
                  className="header-top-apps"
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <span style={{ color: "#fff", fontSize: "14px", fontWeight: "500", marginRight: "2px" }}>Download Apps:</span>
                  <a
                    href="/apks/MilesGoRide-Captain.apk?v=1789218642367"
                    download
                    className="theme-btn"
                    style={{
                      padding: "5px 10px",
                      fontSize: "12px",
                      background: "#49ba09",
                      color: "#fff",
                      border: "none",
                      borderRadius: "4px",
                      textDecoration: "none",
                    }}
                  >
                    <i className="fas fa-download"></i> Driver App
                  </a>
                  <a
                    href="/apks/MilesGoRide-User.apk?v=1789218642367"
                    download
                    className="theme-btn"
                    style={{
                      padding: "5px 10px",
                      fontSize: "12px",
                      background: "#49ba09",
                      color: "#fff",
                      border: "none",
                      borderRadius: "4px",
                      textDecoration: "none",
                    }}
                  >
                    <i className="fas fa-download"></i> User App
                  </a>
                </div>
                {!user && (
                  <div className="header-top-link">
                    {/* Login/Register removed from top header as per request */}
                  </div>
                )}
                <div className="header-top-social">
                  <span>Follow Us: </span>
                  <a
                    href="https://www.facebook.com/share/15mejQrS1C/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-facebook" />
                  </a>
                  <a
                    href="https://www.instagram.com/milesgoride/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ marginLeft: "10px" }}
                  >
                    <i className="fab fa-instagram" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="main-navigation">
          <nav className="navbar navbar-expand-lg">
            <div className="container position-relative">
              <Link
                className="navbar-brand"
                to="/"
                style={{ padding: "10px", borderRadius: "5px" }}
              >
                <img src="/images/logo1.png" alt="logo" />
              </Link>
              <div className="mobile-menu-right">
                <button
                  className="navbar-toggler"
                  type="button"
                  onClick={toggleNav}
                  aria-expanded={isNavOpen}
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-mobile-icon">
                    <i className="far fa-bars" />
                  </span>
                </button>
              </div>
              <div
                className={`collapse navbar-collapse ${isNavOpen ? "show" : ""}`}
                id="main_nav"
              >
                {/* Desktop and Mobile Buttons - SHOWING FIRST */}
                {!isProfilePage && (
                  <div
                    className="nav-right-btn mt-2 d-flex"
                    style={{
                      gap: "10px",
                      marginRight: "20px",
                      marginLeft: "10px",
                    }}
                  >
                    {/* <button
                      onClick={() => { handleNavClick(); navigate('/partner/login'); }}
                      className="theme-btn"
                      style={{ border: 'none', cursor: 'pointer', whiteSpace: 'nowrap' }}y
                    >
                      <span className="fa fa-car" /> MGR Captain
                    </button> */}
                    {/* <button
                      onClick={handleMyAccountClick}
                      className="theme-btn"
                      style={{ border: 'none', cursor: 'pointer', whiteSpace: 'nowrap' }}
                    >
                      <span className="fa fa-user" /> MGR User
                    </button> */}
                  </div>
                )}

                <ul className="navbar-nav">
                  <li className="nav-item">
                    <Link className="nav-link" to="/" onClick={handleNavClick}>
                      Home
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className="nav-link"
                      to="/about"
                      onClick={handleNavClick}
                    >
                      About Us
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className="nav-link"
                      to="/faq"
                      onClick={handleNavClick}
                    >
                      FAQ
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className="nav-link"
                      to="/contact"
                      onClick={handleNavClick}
                    >
                      Contact us
                    </Link>
                  </li>

                  {/* My Account button for mobile -> Renamed to User Account */}
                  {!isProfilePage && (
                    <li className="nav-item d-lg-none">
                      <button
                        onClick={() => {
                          handleNavClick();
                          navigate("/partner/login");
                        }}
                        className="nav-link btn w-100 mt-2 text-white"
                        style={{
                          border: "none",
                          cursor: "pointer",
                          background: "#0B241E",
                          borderRadius: "25px",
                          padding: "10px 20px",
                          fontWeight: "600",
                        }}
                      >
                        <span className="fa fa-car me-2" />
                        MGR Captain
                      </button>
                      <button
                        onClick={handleMyAccountClick}
                        className="nav-link btn btn-success text-white w-100 mt-2"
                        style={{
                          border: "none",
                          cursor: "pointer",
                          background: "#49ba09",
                          borderRadius: "25px",
                          padding: "10px 20px",
                          fontWeight: "600",
                        }}
                      >
                        <span className="fa fa-user me-2" />
                        MGR User
                      </button>
                    </li>
                  )}
                </ul>
                <div className="nav-right">
                  {/* <div className="search-btn">
                    <button type="button" className="nav-right-link">
                      <i className="far fa-search" />
                    </button>
                  </div> */}
                  {!isProfilePage && (
                    <div
                      className="nav-right-btn mt-2"
                      style={{ display: "flex", gap: "10px" }}
                    >
                      <button
                        onClick={() => navigate("/partner/login")}
                        className="theme-btn"
                        style={{ border: "none", cursor: "pointer" }}
                      >
                        <span className="fa fa-car" /> MGR Captain
                      </button>
                      <button
                        onClick={handleMyAccountClick}
                        className="theme-btn"
                        style={{ border: "none", cursor: "pointer" }}
                      >
                        <span className="fa fa-user" />
                        MGR User
                      </button>
                    </div>
                  )}
                  <div className="sidebar-btn">
                    {/* <button type="button" className="nav-right-link">
                      <i className="far fa-bars-filter" />
                    </button> */}
                  </div>
                </div>
              </div>
              {/* search area */}
              <div className="search-area">
                <form action="#">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Type Keyword..."
                    />
                    <button type="submit" className="search-icon-btn"></button>
                  </div>
                </form>
              </div>
            </div>
          </nav>
        </div>
      </header>
    </>
  );
};

export default Navbar;
